import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62d5e45e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "snapshot-list"
};
const _hoisted_2 = {
  class: "tip"
};
const _hoisted_3 = {
  class: "list-block"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "订单包含的宝贝", -1));
const _hoisted_5 = {
  key: 0,
  class: "loading-wrap"
};
const _hoisted_6 = /*#__PURE__*/_createTextVNode("加载中...");
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = {
  class: "right"
};
const _hoisted_10 = {
  class: "row-1"
};
const _hoisted_11 = {
  class: "name"
};
const _hoisted_12 = {
  class: "price"
};
const _hoisted_13 = {
  class: "row-2"
};
const _hoisted_14 = {
  class: "specs ellipsis"
};
const _hoisted_15 = {
  class: "num"
};
const _hoisted_16 = ["onClick"];
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getOrderSnapshotProducts } from '@api';
import { mdToast } from '../../utils/tools';
import MDRouter from '../../service/router';
import domain from '@/service/domain';
export default {
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    const skus = ref([]);
    const content_describe = ref('');
    const fetchList = async () => {
      loading.value = true;
      try {
        // 直接将 query 传入，后端按需读取，如 order_id
        const {
          status,
          data
        } = await getOrderSnapshotProducts({
          ...route.query
        });
        if (status == 0) {
          const result = (data && (data.data || data)).skus || [];
          skus.value = Array.isArray(result) ? result : [];
          //重复添加三次
          skus.value = skus.value.concat(skus.value).concat(skus.value);
          content_describe.value = data.content_describe;
        } else {
          mdToast(data.msg);
        }
      } catch (e) {
        skus.value = [];
      } finally {
        loading.value = false;
      }
    };
    const goDetail = item => {
      const skuOrderId = item.sku_order_id || '';
      const orderId = item.order_id || '';
      router.push({
        path: '/order/snapshot_detail',
        query: {
          sku_order_id: skuOrderId,
          order_id: orderId
        }
      });
      MDRouter.Link(domain.wap + `/order/snapshot_detail?sku_order_id=${skuOrderId}&order_id=${orderId}`);
    };
    onMounted(fetchList);
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_empty = _resolveComponent("van-empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(content_describe.value), 1), _createElementVNode("div", _hoisted_3, [_hoisted_4, loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_loading, {
        size: "24px"
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [skus.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(skus.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.sku_order_id || item.sku_id,
          class: "sku-card"
        }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_image, {
          class: "thumb",
          src: _ctx.$imgUrlFilter(item.product_img, 180),
          fit: "cover",
          "lazy-load": true
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.product_name), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(item.show_sku_price || '￥' + item.sku_price), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.sku_specs), 1), _createElementVNode("div", _hoisted_15, "x " + _toDisplayString(item.num), 1)]), _createElementVNode("div", {
          class: "row-3",
          onClick: $event => goDetail(item)
        }, " 交易快照 ", 8, _hoisted_16)])]);
      }), 128)) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        description: "暂无快照商品"
      }))]))])]);
    };
  }
};